export default {
    install: (app, options) => {
        app.config.globalProperties.$lang = {
            translate(translations, value, def = null) {
                if (value == null) return null;
                if (translations == null) return null;
                return translations[value] ? translations[value] : def;
            },
        };
    }
  }
